// ============================================
// 2026-10-16（P1-3 主相机接线）：主相机 = 漫游相机时，打开场景即应用该相机位姿
// 复用「相机路径镜像」语义（位置=最后一帧，注视点=视线方向(-Z)×10m）；
// 通过 cameraStrategy='custom' + savedCamera 走既有 AutoFitCamera 应用链路（编辑器/预览/发布同源）。
// ============================================
import { mirrorWaypointsFromCameras } from './cameraPathMirror';
import type { PathCamera } from '../types/designer';

export interface MainCameraConfigLike {
  mainCamera?: { type?: string; pathCameraId?: string } | null;
  pathCameras?: PathCamera[] | null;
}

export interface CameraPoseStoreLike {
  setCameraStrategy: (s: 'auto' | 'current' | 'custom') => void;
  setSavedCamera: (c: { position: [number, number, number]; target: [number, number, number] }) => void;
}

/** 应用主相机「漫游相机」位姿；返回是否应用 */
export function applyMainCameraPathPose(cfg: MainCameraConfigLike, store: CameraPoseStoreLike): boolean {
  if (cfg?.mainCamera?.type !== 'path' || !cfg.mainCamera.pathCameraId) return false;
  const cam = (cfg.pathCameras || []).find((c) => c.id === cfg.mainCamera?.pathCameraId);
  if (!cam || !cam.keyFrames?.length) return false;
  const pose = mirrorWaypointsFromCameras([cam])[0];
  store.setCameraStrategy('custom');
  store.setSavedCamera({ position: pose.position, target: pose.target });
  return true;
}
